import { doc, getDoc, setDoc, deleteDoc, serverTimestamp, collection, query, where, getDocs, arrayUnion } from "firebase/firestore";
import { db } from "../firebase/config";

export async function getUserProfileByUid(uid) {
  // 1) authUid로 조회
  const q = query(collection(db, "users"), where("authUid", "==", uid));
  const qSnap = await getDocs(q);
  if (!qSnap.empty) {
    const d = qSnap.docs[0];
    return { uid: d.id, ...d.data() };
  }

  // 2) linkedSocialUid로 조회 (소셜 로그인 연결된 기존 사용자)
  const q2 = query(collection(db, "users"), where("linkedSocialUid", "==", uid));
  const q2Snap = await getDocs(q2);
  if (!q2Snap.empty) {
    const d = q2Snap.docs[0];
    return { uid: d.id, ...d.data() };
  }

  // 2.5) linkedEmailUid로 조회 (아이디 로그인 연결된 기존 사용자)
  const q3 = query(collection(db, "users"), where("linkedEmailUid", "==", uid));
  const q3Snap = await getDocs(q3);
  if (!q3Snap.empty) {
    const d = q3Snap.docs[0];
    return { uid: d.id, ...d.data() };
  }

  // 3) 문서 ID로 직접 조회
  const ref = doc(db, "users", uid);
  const snap = await getDoc(ref);
  if (snap.exists()) return { uid, ...snap.data() };

  return null;
}

export async function initUserDoc({ uid, email, provider }) {
  const providerKey = normalizeProvider(provider);
  const ref = doc(db, "users", uid);
  const snap = await getDoc(ref);
  if (!snap.exists()) {
    await setDoc(ref, {
      email: email || "",
      name: "",
      role: "",
      provider: providerKey,
      providers: providerKey ? [providerKey] : [],
      phoneE164: "",
      phoneVerified: false,
      status: "",
      createdAt: serverTimestamp(),
    });
  }
}

function normalizeProvider(provider) {
  if (!provider) return "";
  if (provider === "google.com" || provider === "google") return "google";
  if (provider === "kakao") return "kakao";
  if (provider === "apple.com" || provider === "apple") return "apple";
  if (provider === "password" || provider === "email") return "email";
  return provider;
}

export async function getUserByPhone(phoneE164) {
  const phoneRef = doc(db, "phones", phoneE164);
  const phoneSnap = await getDoc(phoneRef);
  if (!phoneSnap.exists()) return null;
  const { primaryUid } = phoneSnap.data();
  if (!primaryUid) return null;
  return getUserProfileByUid(primaryUid);
}

export async function linkSocialToExistingUser({ existingUid, socialUid, provider }) {
  const providerKey = normalizeProvider(provider);
  const userRef = doc(db, "users", existingUid);

  // 기존 사용자의 원래 provider도 배열에 함께 추가
  const existingSnap = await getDoc(userRef);
  const existingProvider = existingSnap.exists() ? normalizeProvider(existingSnap.data().provider) : "";
  const providersToAdd = [existingProvider, providerKey].filter(Boolean);

  const updates = { linkedSocialUid: socialUid, updatedAt: serverTimestamp() };
  if (providersToAdd.length > 0) updates.providers = arrayUnion(...providersToAdd);
  await setDoc(userRef, updates, { merge: true });

  // 소셜 로그인으로 생성된 빈 문서 삭제
  try {
    const socialDocRef = doc(db, "users", socialUid);
    const socialSnap = await getDoc(socialDocRef);
    if (socialSnap.exists() && socialSnap.id !== existingUid) {
      await deleteDoc(socialDocRef);
    }
  } catch (e) {
    console.warn("소셜 빈 문서 삭제 스킵:", e.message);
  }
}

export async function linkPhoneToUid({ uid, phoneE164 }) {
  const local = phoneE164.replace(/^\+82/, "0");
  const phone = local.length === 11
    ? `${local.slice(0,3)}-${local.slice(3,7)}-${local.slice(7)}`
    : local;

  const userRef = doc(db, "users", uid);
  await setDoc(userRef, { phoneE164, phone, phoneVerified: true, updatedAt: serverTimestamp() }, { merge: true });

  try {
    const phoneRef = doc(db, "phones", phoneE164);
    await setDoc(phoneRef, { primaryUid: uid, updatedAt: serverTimestamp() }, { merge: true });
  } catch (e) {
    console.warn("phones 인덱스 저장 실패 (무시):", e.message);
  }
  try {
    const indexRef = doc(db, "users_by_phone", phoneE164);
    await setDoc(indexRef, { uid, phoneE164, updatedAt: serverTimestamp() }, { merge: true });
  } catch (e) {
    console.warn("users_by_phone 인덱스 저장 실패 (무시):", e.message);
  }
}
